import React from 'react';
import { useTranslation } from 'react-i18next';
import AdminBreadcrumb from '../components/AdminBreadcrumb';
import Calendar from '../components/Calendar';

const CalendarPage = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-7xl mx-auto px-4">
        <AdminBreadcrumb />
        <div className="bg-white rounded-xl shadow-lg p-6 md:p-8">
          <div className="mb-6">
            <h1 className="text-3xl font-bold text-gray-900">{t('calendar.title') || 'Lịch Xem Nhà'}</h1>
            <p className="text-gray-600 mt-2">{t('calendar.subtitle') || 'Quản lý lịch hẹn xem phòng trọ'}</p>
          </div>
          
          <Calendar />
        </div>
      </div>
    </div>
  );
};

export default CalendarPage;